import React from "react";
import AccessDenied from "../../component/404/AccessDenied";

function Access() {
  return <AccessDenied type="error" />;
}

Access.auth = { path: "/denied", role: "all" };
export default Access;
